import type { Location } from '@atlassian/react-resource-router';
import { createRouterSelector } from '@atlassian/react-resource-router/src/controllers/router-store';

// oxlint-disable-next-line typescript/no-invalid-void-type
export const useLocation: (args_0: void) => Location = createRouterSelector(
	(state) => state.location,
);
